import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth, onAuthStateChanged, type User } from 'firebase/auth'
import { resolveAuthEmulatorUrl } from './firebaseAuthRuntime'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
}

const firebaseApp = initializeApp(firebaseConfig)
export const auth = getAuth(firebaseApp)

// ローカルで実行中の場合は、エミュレータを使う
const authEmulatorUrl = resolveAuthEmulatorUrl({
  DEV: import.meta.env.DEV,
  VITE_FIREBASE_AUTH_EMULATOR_HOST: import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST,
})
if (authEmulatorUrl) {
  console.log('firebase auth emulator:', authEmulatorUrl)
  connectAuthEmulator(auth, authEmulatorUrl)
}

const waitForCurrentUser = async (timeoutMs = 3000): Promise<User | null> => {
  if (auth.currentUser) return auth.currentUser

  return await new Promise<User | null>((resolve) => {
    const timer = setTimeout(() => {
      unsubscribe()
      resolve(auth.currentUser)
    }, timeoutMs)

    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        clearTimeout(timer)
        unsubscribe()
        resolve(user)
      },
      () => {
        clearTimeout(timer)
        unsubscribe()
        resolve(null)
      }
    )
  })
}

/**
 * バックエンドAPI呼び出し用の ID トークンを取得する。
 * - 未ログインなら null
 * - Firebase SDK 側で期限切れ時の更新が走る
 */
export const getIdToken = async (): Promise<string | null> => {
  const user = await waitForCurrentUser()
  if (!user) return null

  return await user.getIdToken()
}
